import { RevenueBandAnswer, TaxClassificationAnswer } from '@commenda/api';
import { SelectOption } from './fieldOptions.types';

/** Wizard form-data keys for Part 1 (intake). */
export const INTAKE_FIELDS = {
  FISCAL_YEAR: 'fiscalYear',
  COMPLIANCE_CATEGORIES: 'complianceCategories',
} as const;

export const REVENUE_BAND_OPTIONS: { value: RevenueBandAnswer; label: string }[] =
  [
    { value: 'PRE_REVENUE', label: 'Pre-revenue' },
    { value: 'UNDER_1M_USD', label: 'Under $1M' },
    { value: 'MID_1M_10M_USD', label: '$1M – $10M' },
    { value: 'LARGE_10M_PLUS_USD', label: '$10M+' },
  ];

export const TAX_CLASSIFICATION_OPTIONS: {
  value: TaxClassificationAnswer;
  label: string;
}[] = [
  { value: 'C_CORPORATION', label: 'C Corporation' },
  { value: 'S_CORPORATION', label: 'S Corporation' },
  { value: 'PARTNERSHIP', label: 'Partnership' },
];

export const YES_NO_OPTIONS: SelectOption[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];
